import type { ZudokuConfig } from "zudoku";

const config: ZudokuConfig = {
  sidebar: {
    docs: [
      {
        type: "category",
        label: "Overview",
        icon: "book",
        items: ["docs/introduction", "docs/banks"]
      },
      {
        type: "category",
        label: "Guides",
        icon: "sparkles",
        items: ["docs/getstarted", "docs/api", "docs/get_access_token", "docs/list_banks", "docs/create_consent", "docs/list_accounts", "docs/quickstart_pis", "docs/iso_payments", "docs/kyc", "docs/payouts"]
      },
      {
        type: "category",
        label: "Other Information",
        icon: "info",
        items: [ "docs/credentials", "docs/glossary", "docs/enums", "docs/error_messages"]
      },
      {
        type: "category",
        label: "Changelog",
        icon: "rocket",
        items: [ "docs/changelog/2025-04", "docs/changelog/2025-05", "docs/changelog/2025-06" ]
      },
      {
        type: "category",
        label: "Downloads",
        icon: "download",
        items: [ {
          type: "link",
          label: "OpenAPI Reference",
          href: "https://docs.openpayments.io/openpayments_api.yaml",
        },
        {
          type: "link",
          label: "Postman Collection",
          href: "https://docs.openpayments.io/obp.postman_collection.json"
        },
        {
          type: "link",
          label: "Postman Environment",
          href: "https://docs.openpayments.io/production.postman_environment.json"
        }    
        ]
      },
      {
        type: "category",
        label: "Support",
        icon: "mail-question",
        items: ["docs/support", 
          {
          type: "link",
          label: "Terms & Conditions",
          href: "https://docs.openpayments.io/legal/Terms%20%26%20Conditions.pdf"
          },
          {
            type: "link",
            label: "Privacy Policy",
            href: "https://docs.openpayments.io/legal/PrivacyPolicy2023.pdf"
          },
          {
            type: "link",
            label: "Main Website",
            href: "https://openpayments.io"
          }
        ]
      }
    ],
  },
  topNavigation: [
    { label: "Documentation", id: "docs/introduction" },
    { label: "API Reference", id: "api" }
  ],
  metadata: {
    title: "Open Payments Documentation",
    favicon: "/favicon.png"
  },
  redirects: [{ from: "/", to: "/docs/introduction" }],
  apis: {
    type: "file",
    input: "./public/openpayments_api.yaml",
    navigationId: "api",
  },
  docs: {
    files: "/pages/**/*.{md,mdx}",
  },
  page: {
    showPoweredBy: false,
    pageTitle: "",
    logo: {
      src: {
        light: "OP-logotype-regular.png",
        dark: "OP-logotype-regular-dark.png"
      }
    }
  },
  theme: {
    fonts: {
      sans: {
        fontFamily: "Scto Grotesk A, Open Sans, sans-serif",
        url: "/fonts.css"
      }
    },
    light: {
      background: "0 0% 100%",
      foreground: "0 0% 3.9%",
      card: "0 0% 100%",
      cardForeground: "0 0% 3.9%",
      popover: "0 0% 100%",
      popoverForeground: "0 0% 3.9%",
      primary: "0 0% 9%",
      primaryForeground: "0 0% 98%",
      secondary: "0 0% 96.1%",
      secondaryForeground: "0 0% 9%",
      muted: "0 0% 96.1%",
      mutedForeground: "0 0% 45.1%",
      accent: "0 0% 96.1%",
      accentForeground: "0 0% 9%",
      destructive: "0 84.2% 60.2%",
      destructiveForeground: "0 0% 98%",
      border: "0 0% 89.8%",
      input: "0 0% 89.8%",
      ring: "0 0% 3.9%",
      radius: "0.8rem"
    },
    dark: {
      background: "0 0% 3.9%",
      foreground: "0 0% 98%",
      card: "0 0% 3.9%",
      cardForeground: "0 0% 98%",
      popover: "0 0% 3.9%",
      popoverForeground: "0 0% 98%",
      primary: "0 0% 98%",
      primaryForeground: "0 0% 9%",
      secondary: "0 0% 14.9%",
      secondaryForeground: "0 0% 98%",
      muted: "0 0% 14.9%",
      mutedForeground: "0 0% 63.9%",
      accent: "0 0% 14.9%",
      accentForeground: "0 0% 98%",
      destructive: "0 62.8% 30.6%",
      destructiveForeground: "0 0% 98%",
      border: "0 0% 14.9%",
      input: "0 0% 14.9%",
      ring: "0 0% 83.1%",
      radius: "0.5rem"
    }
  }
};

export default config;
